<template>
  <div class="zhuanshudingding">
    <div class="banner"></div>
    <div class="cont1">
      <p>推荐以下群聊</p>
      <div class="line"><div class="line1"></div></div>
      <div class="small">
        1000万组织正在用，群内配套丰富功能，选择你所需要的
      </div>
    </div>
    <div class="cont2">
      <div class="all">
        <div class="top">
          <div class="imp">
            <span class="title">项目群</span>&nbsp;<span>☆推荐</span>
          </div>
          <p>群里分配工作任务，追踪项目进度</p>
        </div>
        <div class="content">
          <div class="num">任务清单</div>
          <div class="num">我的任务</div>
          <div class="num">项目概况</div>
          <div class="num">成员管理</div>
        </div>
      </div>
      <div class="all">
        <div class="top">
          <div class="imp">
            <span class="title">培训群</span>&nbsp;<span>☆推荐</span>
          </div>
          <p>线上线下，轻松做培训</p>
        </div>
        <div class="content">
          <div class="num1">培训管理</div>
          <div class="num1">学习圈</div>
          <div class="num1">群直播</div>
          <div class="num1">作业</div>
          <div class="num1">课件</div>
          <div class="num1" style="opacity: 0">成员管理</div>
        </div>
      </div>
      <div class="all">
        <div class="top">
          <div class="imp">
            <span class="title">培训群</span>&nbsp;<span>☆推荐</span>
          </div>
          <p>线上线下，轻松做培训</p>
        </div>
        <div class="content">
          <div class="num1">健康打卡</div>
          <div class="num1">疫情动态</div>
          <div class="num1">群签到</div>
          <div class="num1">群直播</div>
          <div class="num1">群文件</div>
          <div class="num1">视频会议</div>
        </div>
      </div>
      <div class="all">
        <div class="top">
          <div class="imp"><span class="title">签到打卡群</span>&nbsp;</div>
          <p>群里就能签到打卡</p>
        </div>
        <div class="content">
          <div class="num">群签到</div>
          <div class="num">打卡</div>
          <div class="num">视频会议</div>
          <div class="num">群公告</div>
        </div>
      </div>
      <div class="all">
        <div class="top">
          <div class="imp"><span class="title">团队文化群</span>&nbsp;</div>
          <p>团队文化建设阵地</p>
        </div>
        <div class="content">
          <div class="num">圈子</div>
          <div class="num">晒照片</div>
          <div class="num">群直播</div>
          <div class="num" style="opacity: 0">成员管理</div>
        </div>
      </div>
      <div class="all">
        <div class="top">
          <div class="imp">
            <span class="title">值班群</span>&nbsp;<span>☆推荐</span>
          </div>
          <p>一键设置即可自动提醒</p>
        </div>
        <div class="content">
          <div class="num1">值班表</div>
          <div class="num1">设置值班</div>
          <div class="num1">视频会议</div>
          <div class="num1">紧急通知</div>
          <div class="num1">群汇报</div>
          <div class="num1">群签到</div>
        </div>
      </div>
    </div>
    <div class="bgc">
      <div class="cont3">
      <div class="all">
        <div class="title">疫情专区</div>
        <p>每日关注疫情和健康</p>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/f50151a9-ae09-454d-b9b0-1aec02660d12.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">员工健康</span>&nbsp;<span>☆推荐</span>
            </div>
            <p>健康打卡，守护员平安</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/26af0ab9-e124-4801-9c70-2f0c9091e718.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">疫情动态</span>&nbsp;
            </div>
            <p>全国疫情数据，实时更新</p>
          </div>
        </div>
      </div>
      <div class="all">
        <div class="title">云端开会</div>
        <p>不用面对面，也能高效开会</p>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/c785bae4-4acb-4d3d-bbb8-82435c839bff.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">视频会议</span>&nbsp;<span>302人</span>
            </div>
            <p>清晰稳定，免费302方同时在线</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/f50151a9-ae09-454d-b9b0-1aec02660d12.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">群直播</span>&nbsp;<span>☆推荐</span>
            </div>
            <p>远程授课、企业培训、大型会议</p>
          </div>
        </div>
      </div>
      <div class="all">
        <div class="title">文档协作</div>
        <p>多人共同在线编辑文档</p>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/7d92f4ba-98c9-453c-a920-3f5e9e1a5f0a.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">群文件</span>&nbsp;
            </div>
            <p>文件分门别类，文档在线编辑</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/588ad23d-4991-4bba-9298-323d913841b8.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">智能填表</span>&nbsp;
            </div>
            <p>问卷调查、人员登记、信息收集</p>
          </div>
        </div>
      </div>



      <div class="all all-1">
        <div class="title">沟通协同</div>
        <p>远程办公，全员步调要一致</p>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/a6765a5f-85e1-45aa-b684-ec8b104376be.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">紧急通知</span>&nbsp;
            </div>
            <p>十万火急消息，快速通知全员</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/d5fbf7df-75fd-46c6-9a50-8a76f2a1424c.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">群公告</span>&nbsp;
            </div>
            <p>发布重要公告，群内自动置顶</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/aff778b0-186e-4419-ad43-63b3e64fe07f.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">群签到</span>&nbsp;<span>☆推荐</span>
            </div>
            <p>远程上班签到，统计出勤信息</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/8631c2c4-c1e9-4bf2-b3fb-3483d0ab8d83.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">群汇报</span>&nbsp;<span>☆推荐</span>
            </div>
            <p>日报周报等模板汇报工作进展</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/5c14b68e-aa16-47a0-ad40-655ef78f2d30.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">群投票</span>&nbsp;
            </div>
            <p>投票结果实时统计，一目了然</p>
          </div>
        </div>
      </div>



      <div class="all all-1">
        <div class="title">团队文化</div>
        <p>提升团队凝聚力，共渡过难关</p>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/05f79cea-e193-4649-b1e5-6728a632fd5b.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">全员圈</span>&nbsp;
            </div>
            <p>企业文化在线，员工内部论坛</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/349bce5e-a967-4632-91f3-969d73938432.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">公益树</span>&nbsp;
            </div>
            <p>团队一起做公益，提升凝聚力</p>
          </div>
        </div>
        <div class="big">
          <div class="img">
            <img
              src="http://img601.yun300.cn/repository/image/4ab3afb2-36fe-4d1a-8cd8-68af167ee0fc.png?tenantId=214689&viewType=1&k=1652767575000"
              alt=""
            />
          </div>
          <div class="left">
            <div class="content">
                <span class="title">团队运动</span>&nbsp;
            </div>
            <p>邀请成员运动，激发团队活力</p>
          </div>
        </div>
      </div>
    </div>
    <div class="cont3s">
      <div class="zhuanjia">
        <p class="bushuzhuanjia">部署专家免费服务</p>
        <p class="zhuanjiafuwu">
          <span>联系部署专家：</span
          >根据您提交的需求，将有钉钉部署专家免费为您服务！
        </p>
        <div class="btn-zixun" @click="jumpZX">立即咨询</div>
      </div>
      <div class="sssdd"></div>
    </div>
    </div>
  </div>
</template>
        
<script>
export default {
  methods: {
    jumpZX() {
                  window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

    },
  },
};
</script>
<style lang='less' scoped>
.bgc{
  width: 100%;
  // background-color:red;
  background-color: rgba(245, 245, 245, 1);
}
.zhuanshudingding {
  width: 100%;
  text-align: left;
  .banner {
    width: 100%;
    height: 450px;
    background-image: url(./banner-pc-img/jjfa_ydbgs_1920337.5@1x.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .cont1 {
    width: 80%;
    margin: 40px auto 40px;
    > p {
      font-size: 35px;
      color: #000000;
      text-align: center;
    }
    > .line {
      width: 100%;
      margin: 15px 0;
      > .line1 {
        width: 80px;
        height: 4px;
        background-color: rgb(83, 137, 253);
        margin: 0 auto;
      }
    }
    > .small {
      font-size: 22px;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 20px;
      color: #000;
    }
  }
  .cont2 {
    width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    > .all {
      width: 32%;
      background-color: rgba(245, 192, 67, 0.2);
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 40px;
      > .top {
        background-color: rgba(245, 192, 67, 1);
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        padding-bottom: 25px;
        > .imp {
          width: 100%;
          padding: 15px 0px;
          > span {
            font-size: 14px;
            color: #ffff00;
            
          }
          > .title {
            font-size: 20px;
            color: #fff;
          }
        }
        > p {
          font-size: 14px;
          color: #fff;
        }
      }
      > .content {
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        overflow: hidden;
        padding: 35px 0 0;
        padding: 20px;
        > .num {
          padding: 8px 20px;
          box-sizing: border-box;
          text-align: center;
          line-height: 36px;
          padding: 0 20px;
          background-color: #fff;
          border-radius: 8px;
          overflow: hidden;
          font-size: 14px;
          margin-top: 10px;
        }
        > .num1 {
          padding: 8px 20px;
          box-sizing: border-box;
          text-align: center;
          background-color: #fff;
          border-radius: 8px;
          overflow: hidden;
          font-size: 14px;
          margin-top: 10px;
        }
      }
      &:nth-child(2) {
        background-color: rgba(61, 209, 139, 0.2);
        > .top {
          background-color: rgba(61, 209, 139, 1);
        }
      }
      &:nth-child(3) {
        background-color: rgba(78, 163, 248, 0.2);
        > .top {
          background-color: rgba(78, 163, 248, 1);
        }
      }
      &:nth-child(4) {
        background-color: rgba(252, 153, 80, 0.2);
        > .top {
          background-color: rgba(252, 153, 80, 1);
        }
      }
      &:nth-child(5) {
        background-color: rgba(124, 151, 235, 0.2);
        > .top {
          background-color: rgba(124, 151, 235, 1);
        }
      }
      &:nth-child(6) {
        background-color: rgba(250, 129, 112, 0.2);
        > .top {
          background-color: rgba(250, 129, 112, 1);
        }
      }
    }
  }
  .cont3 {
    width: 80%;
    margin: 10px auto 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: rgba(245, 245, 245, 1);
    box-sizing: border-box;
    padding: 20px 0;
    > .all {
      width: 19%;
      box-sizing: border-box;
      padding: 10px;
      > .title {
        font-size: 26px;
        color: #000;
        padding: 0 20px;
        margin-bottom: 15px;
        
      }
      > p {
        font-size: 19px;
        padding: 0 20px;
        color: #696969;
      }
      > .big {
        width: 100%;
        background-color: white;
        margin-top: 15px;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        padding: 20px;
        > .img {
          width: 50px;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          padding-top: 20px;
          > img {
            width: 50px;
            height: 50px;
          }
        }
        > .left {
          width: calc(100% - 50px);
          height: 100%;
          padding: 15px;
          padding-right: 0px;
          >.content{
             
              >span{
                  font-size: 14px;
                  color: red;
              }
              >.title{
                  font-size: 18px;
                  color: #000;
              }
          }
          >p{
              font-size: 16px;
              color: #696969;
              margin: 5px 0;
          }
          >.more{
              font-size: 12px;
              color: #0089ff;
              }
        }
      }
    }
    > .all-1{
    }
  }
}

.cont3s {
  width: 100%;
  // background-color: #fff !important;
  background-color: rgba(245, 245, 245, 1);
  .zhuanjia{
            width: 80%;
            background-color: #fff;
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
  .sssdd {
    height: 25px;
  }
}
</style>